import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WhatsAppCTA } from "../components/WhatsAppCTA";

// Shared layout for legal / info pages — same dark visual identity.
export default function LegalLayout({ title, intro, children, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid={testId}
      className="relative bg-[#050505] pt-36 pb-32 min-h-screen"
    >
      <div className="absolute inset-0 spotlight pointer-events-none" />
      <div className="relative w-full max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1 className="text-4xl md:text-6xl font-bold tracking-tighter leading-[0.98] text-[#f5f5f7]">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-base md:text-lg text-[#86868b] leading-relaxed">
              {intro}
            </p>
          )}

          <div className="mt-12 space-y-10 text-[#86868b] text-[15px] leading-relaxed">
            {children}
          </div>

          <div className="mt-16">
            <WhatsAppCTA
              label="Falar no WhatsApp"
              icon={<MessageCircle size={18} />}
              testId="legal-whatsapp"
            />
          </div>
        </motion.div>
      </div>
    </main>
  );
}

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="text-xl md:text-2xl font-bold tracking-tight text-[#f5f5f7] mb-4">
      {heading}
    </h2>
    <div className="space-y-4">{children}</div>
  </section>
);
